import { CustomerGarageFilterModel } from "./CustomerGarageFilterModel";

export class MassiveCustomerUpdate {
    public selectedCustomerId?: Array<string>;
    public deselectedCustomerId?: Array<string>;
    public selectAll?: boolean;
    public idSalesman?: string;
    public currentSearch?: CustomerGarageFilterModel;
}